import { Axios } from "./request";

const API_URL = "branchesapi/v1/baseInfos/";

export const BASE_INFOS_API = {
  GetProvincesByCountryId: (countryId) => {
    return Axios.get(`${API_URL}GetProvincesByCountryId/?countryId=${countryId}`);
  },
  GetAllCountries: () => {
    return Axios.get(`${API_URL}GetAllCountries`);
  },
  GetCitiesByProvinceId: (provinceId) => {
    return Axios.get(`${API_URL}GetCitiesByProvinceId/?provinceId=${provinceId}`);
  },
  GetRegionsByCityId: (cityId) => {
    return Axios.get(`${API_URL}GetRegionsByCityId/?cityId=${cityId}`);
  },
  GetIranProvinces: () => {
    return Axios.get(`${API_URL}GetProvincesByCountryId?countryId=1`);
  },
  GetResidencePrioritiesByCountryId: (countryId) => {
    return Axios.get(`${API_URL}GetResidencePrioritiesByCountryId?countryId=${countryId}`);
  },
};
